import { SET_DOMAIN } from '../actionTypes';

const initialState = '';

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DOMAIN: {
      return action.payload;
    }
    default:
      return state;
  }
};
